const addressSchema = {
  email: '',
  street: '',
  postcode: '',
  city: '',
  province: '',
  country: '',
  dialCode: '',
  telephone: '',
}

export default {
  addressSchema,
}
